var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 26.323c0-3.961 1.354-8.165 4.062-12.612 2.746-4.485 7.68-8.576 14.803-12.276l1.336 2.522c-3.562 2.542-6.196 4.672-7.902 6.39C9.293 13.45 7.79 16.42 7.79 19.26c0 .972.278 1.607.835 1.906.556.336 1.038.504 1.447.504 1.41-.186 2.337-.28 2.782-.28 2.374 0 4.322.878 5.843 2.635 1.521 1.719 2.282 3.811 2.282 6.278 0 2.765-.835 5.082-2.504 6.95-1.67 1.831-3.97 2.747-6.9 2.747-3.451 0-6.252-1.233-8.404-3.7C1.057 33.797 0 30.47 0 26.323zm25.02-1.435c0-4.186 1.447-8.502 4.34-12.949C32.256 7.494 37.097 3.514 43.886 0l1.336 2.522c-3.34 2.355-5.899 4.429-7.68 6.222-3.153 3.177-4.73 6.129-4.73 8.857 0 .785.204 1.42.612 1.906.408.485.965.728 1.67.728 1.41-.186 2.337-.28 2.782-.28 2.337 0 4.267.86 5.788 2.579C45.22 24.253 46 26.364 46 28.868c0 2.915-.853 5.269-2.56 7.063-1.706 1.756-4.025 2.634-6.956 2.634-3.34 0-6.085-1.233-8.236-3.7-2.152-2.503-3.228-5.83-3.228-9.977z",
    fill: "#217E00"
  })));
}

export default SvgGreenQuote;